/**
  * domain域主表模块接口列表
  */

//  import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const domain = {
  
  
  //获取下拉框的接口 从redis中
  domainGetDomainKeyRedis: params => { 
	  return axios.post('domain-manager/domain/getDomainKeyRedis',qs.stringify(params));
},

//获取下拉框的接口 从DB中
  domainGetDomainKeyDB: params => { 
	  return axios.post('domain-manager/domain/getDomainKeyDB',qs.stringify(params));
},

// 商品标签特征查询页面中商品下拉框的查询
  getItemMastersByItemCodeOrItemNamePage: params => { 
	  return axios.post('commoditymanagement/itemMaster/getItemMastersByItemCodeOrItemNamePage',qs.stringify(params));
},
// 请求多个域

getDomainKeysReturnMapRedis: params => { return axios.get('domain-manager/domain/getDomainKeysReturnMapRedis', { params: params }); },
}

export default domain;


// WEBPACK FOOTER //
// ./src/api/api_domain.js